export default function () {
  const menu = document.getElementById('menu-header');
	const menuHeight = menu?.offsetHeight || 130;
  const hiddenLinks = menu?.querySelectorAll('.hide-on-scroll .group-item');
	let lastScrollTop = 0;
	let scrollDirection = 'down';
	let scrollPosition = window.scrollY;

	window.addEventListener('scroll', () => {
		toggleMenu();
	});

	function toggleMenu() {
		scrollPosition = window.scrollY;
		if (scrollPosition > lastScrollTop) {
			scrollDirection = 'down';
		} else {
			scrollDirection = 'up';
		}
		lastScrollTop = scrollPosition;
		if (scrollPosition > menuHeight) {
			menu?.classList.add('menu-hidden');
      hiddenLinks.forEach(link => {
        link.setAttribute('inert', '');
      });
		} else {
			menu?.classList.remove('menu-hidden');
      hiddenLinks.forEach(link => {
        link.removeAttribute('inert');
      });
		}
	}

	toggleMenu();
}
